
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/pricing-ab-testing/pricing-ab-testing-for-html",
      function () {
        return require("private-next-pages/help-centre/pricing-ab-testing/pricing-ab-testing-for-html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/pricing-ab-testing/pricing-ab-testing-for-html"])
      });
    }
  